module.exports = __webpack_public_path__ + "static/media/bar-brewery-winery-2.03179617.jpg";